<template>
  <div class="artWork has-navbar-fixed-top">
    <div class="wrapper">
      <Header />
      <div class="frow">
        <div class="box">
          <div class="frow gutters">
            <div class="col-md-1-3">
              <nav class="panel">
                <p class="panel-heading">
                  Settings
                </p>
              </nav>
            </div>
          </div>
          <div class="frow gutters mb-20">
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="imageBankHeight"
                >
                  Image Bank Height
                </label>
                <small>e.x. 52px, 20%, 3rem</small>
                <input
                  id="imageBankHeight"
                  v-model="settings.imageBankHeight"
                  class="input"
                  name="imageBankHeight"
                  type="text"
                >
              </div>
            </div>
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="activeImageHeight"
                >
                  Active Image Height
                </label>
                <small>e.x. 500px, 40%, 6rem</small>
                <input
                  id="activeImageHeight"
                  v-model="settings.activeImageHeight"
                  class="input"
                  name="activeImageHeight"
                  type="text"
                >
              </div>
            </div>
          </div>
          <div class="frow gutters mb-20">
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="metaTitle"
                >
                  Meta Title
                </label>
                <input
                  id="metaTitle"
                  v-model="settings.metaTitle"
                  class="input"
                  name="metaTitle"
                  type="text"
                >
              </div>
            </div>
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="metaDescription"
                >
                  Meta Description
                </label>
                <textarea
                  id="metaDescription"
                  v-model="settings.metaDescription"
                  class="input"
                  name="metaDescription"
                />
              </div>
            </div>
            <div class="frow gutters mb-20 width-100">
              <div class="col-sm-1-1">
                <div class="field">
                  <label
                    class="label"
                    for="categories"
                  >
                    Categories
                  </label>
                  <small>You can only remove or add categories. NO EDITING</small>
                  <textarea
                    id="categories"
                    v-model="settings.categories"
                    class="textarea"
                    name="categories"
                    rows="8"
                  />
                </div>
              </div>
              <button
                class="button is-success mt-20"
                :class="{'is-loading': saving}"
                @click.prevent="saveSettings"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header.vue';

export default {
  name: 'Settings',
  components: {
    Header,
  },
  data() {
    return {     
      saving: false,
      settings: {},
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
  },
  created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/admin/login');
    } else {
      this.getSettings();
    }
  },
  methods: {
    getSettings() {
      this.axios.get(`${this.$API}/settings`).then((response) => {
        this.settings = response.data[0];
        this.settings.categories = this.settings.categories.toString();
      });
    },
    saveSettings() {
      this.saving = true;
      const method = 'PUT';
      const url = `${this.$API}/settings/${this.settings.id}`;
      const data = Object.assign({}, this.settings);
      data.categories = JSON.stringify(this.sortCategories(data.categories.split(',')));
      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            this.saving = false;
            this.$snotify.success('Settings saved','Success');
            this.settings.categories = JSON.parse(data.categories);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(err, 'Saving failed', {
            timeout: 10000,
            showProgressBar: false,
          });
        });
    },
    sortCategories(categories) {
      return[...new Set(categories.sort((a, b) => {
        let A = a.toUpperCase(); 
        let B = b.toUpperCase(); 
        if (A < B) {
          return -1;
        }
        if (A > B) {
          return 1;
        }
        return 0;
      }))];
    },
  },
};
</script>
<style lang="scss" scoped>
.artWork {
  background-color: #fff;
  height: 100%;
  width: 100%;
}
.wrapper {
  margin: auto;
  margin-top: 50px;
  width: 90%;
}
.logout {
  cursor: pointer;
}
.box {
  margin-top: 50px;
  width: 100%;
}
form {
  overflow: scroll;
  max-height: 800px;
}

.panel-block {
  &.is-active {
    background: black;
    color: #fff !important;
  }
}
</style>
